import React from 'react';
import { BLOCKS, MARKS, INLINES } from '@contentful/rich-text-types';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _richTextReactRenderer = require("@contentful/rich-text-react-renderer");
var _contentfulResolveResponse = _interopRequireDefault(require("contentful-resolve-response"));

import RichListItem from '../rich-components/rich-list-item';
import RichHeading from '../rich-components/rich-heading';
import RichQuote from '../rich-components/rich-quote';
import RichParagraph from '../rich-components/rich-paragraph';
import RichCode from '../rich-components/rich-code';
import RichAssetPreview from '../rich-components/rich-components-preview/rich-asset-preview';
import RichEntryPreview from '../rich-components/rich-components-preview/rich-entry-preview';
import RichHyperlinkPreview from '../rich-components/rich-components-preview/rich-hyperlink-preview';

/**
 * Function which accepts a rich text JSON object and converts it into styled
 * react components using a combination of custom components, and standard elements
 * configured for rich-text-react-renderer
 *
 * @function renderRichText
 * @returns {jsx} The JSX comprised of a collection of rendered components
 */
const renderRichTextPreview = ( parsedRaw ) => {
  const richText = parsedRaw;
  const references = richText.content;
  let returnedAssets = []
  let returnedEntries = []

  const options = {
    renderMark: {
      [MARKS.CODE]: RichCode,
      subscript: text => <span style={{ verticalAlign: "sub" }}>{text}</span>,
      superscript: text => <span style={{ verticalAlign: "super" }}>{text}</span>
    },
    renderNode: {
      [BLOCKS.HEADING_1]: RichHeading,
      [BLOCKS.HEADING_2]: RichHeading,
      [BLOCKS.HEADING_3]: RichHeading,
      [BLOCKS.HEADING_4]: RichHeading,
      [BLOCKS.HEADING_5]: RichHeading,
      [BLOCKS.HEADING_6]: RichHeading,
      [BLOCKS.LIST_ITEM]: RichListItem,
      [BLOCKS.QUOTE]: RichQuote,
      [BLOCKS.PARAGRAPH]: RichParagraph,
      [INLINES.HYPERLINK]: RichHyperlinkPreview,
      [BLOCKS.EMBEDDED_ASSET]: () => {
        for (let i = 0; i < references.length; i++) {
          const richAssetContent = references && RichAssetPreview(references[i]);

          if (richAssetContent && !returnedAssets.includes(i)) {
            returnedAssets.push(i)
            return richAssetContent
          }
        }
      },
      [BLOCKS.EMBEDDED_ENTRY]: () => {
        for (let i = 0; i < references.length; i++) {
          const richEntryContent = references && RichEntryPreview(references[i]);

          if (richEntryContent && !returnedEntries.includes(i)) {
            returnedEntries.push(i)
            return richEntryContent
          }
        }
      },
    }
  };
  return _richTextReactRenderer.documentToReactComponents(richText, options);
};

export default renderRichTextPreview